import { render, staticRenderFns } from "./agreementItemBreakdown.vue?vue&type=template&id=45917e37"
import script from "./agreementItemBreakdown.vue?vue&type=script&lang=js"
export * from "./agreementItemBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports